var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobilePhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "70px",
    viewBox: "0 0 41 70",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_mobile-phone_1433204"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.29167 0L32.8125 0C36.8331 0 40.1042 3.27104 40.1042 7.29167L40.1042 62.4663C40.1042 66.4869 36.8331 69.7579 32.8125 69.7579L7.29167 69.7579C3.27104 69.7579 0 66.4869 0 62.4663L0 7.29167C0 3.27104 3.27104 0 7.29167 0ZM2.91667 57.7267L37.1875 57.7267L37.1875 7.29167C37.1875 4.87885 35.2253 2.91667 32.8125 2.91667L7.29167 2.91667C4.87885 2.91667 2.91667 4.87885 2.91667 7.29167L2.91667 57.7267ZM20.0521 5.71375C17.7742 5.71375 15.9206 7.56729 15.9206 9.84521C15.9206 12.1231 17.7742 13.9767 20.0521 13.9767C22.33 13.9767 24.1835 12.1231 24.1835 9.84521C24.1835 7.56729 22.33 5.71375 20.0521 5.71375ZM18.8373 9.84521C18.8373 10.5153 19.382 11.06 20.0521 11.06C20.7222 11.06 21.2669 10.5153 21.2669 9.84521C21.2669 9.1751 20.7222 8.63042 20.0521 8.63042C19.382 8.63042 18.8373 9.1751 18.8373 9.84521ZM37.1875 62.4662C37.1875 64.8791 35.2253 66.8412 32.8125 66.8412L7.29167 66.8412C4.87885 66.8412 2.91667 64.8791 2.91667 62.4662L2.91667 60.6433L37.1875 60.6433L37.1875 62.4662Z",
    transform: "translate(0.3645833 0.1210417)",
    id: "Shape",
    fill: "#FFDA1A",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePhoneIcon);
export default __webpack_public_path__ + "static/media/mobile-phone-icon.7cfd64cc42adce8dccac50a45f597ea2.svg";
export { ForwardRef as ReactComponent };